import getters from './getters'
import actions from './actions'
import mutations from './mutations'

// localStorage holds a string: "false" must not read as collapsed.
function storedCollapsed() {
  try {
    return localStorage.getItem('collapsed') === 'true'
  } catch {
    return false
  }
}

export default {
  namespaced: true,
  state() {
    return {
      collapsed: storedCollapsed(),
      menu: [
        {
          icon: 'folder-open',
          pageName: 'work_progress_route',
          title: 'work_progress',
          // A work's pages and the new work form belong to this entry.
          alsoActiveOn: ['work_edit_route', 'work_create_route']
        },
        {
          icon: 'archive',
          pageName: 'work_archived_route',
          title: 'work_archived'
        },
        {
          icon: 'database',
          pageName: 'urn_index_route',
          title: 'urn_title',
          gate: 'see_planning'
        },
        {
          icon: 'calendar-day',
          pageName: 'planning_page_route',
          title: 'planning_title',
          gate: 'see_planning'
        },
        {
          icon: 'file-invoice-dollar',
          pageName: 'invoicing_page_route',
          title: 'invoicing_title_main',
          gate: 'see_invoicing',
          meta: { open_for_customer: true }
        },
        {
          icon: 'book-open',
          pageName: 'note_index_route',
          title: 'note',
          gate: 'see_content'
        },
        {
          icon: 'analytics',
          pageName: 'stats_index_route',
          title: 'stats',
          gate: 'see_content'
        },
        {
          icon: 'cogs',
          pageName: 'settings_list_user_route',
          title: 'settings',
          gate: 'see_content'
        }
      ]
    }
  },
  mutations,
  actions,
  getters
}
